import {
  aiMarketImg,
  instructorsMarkeImg,
  learnersMarketImg,
  scormMarketImg,
  storageMarketImg,
} from '../../../assets/images';
import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';
import {
  SUBSCRIPTION_TRIAL,
  SUBSCRIPTION_ENTERPRISE,
  isBusinessSubscription,
  isCreatorSubscription,
  isAnnualSubscription,
} from '../config';

export const ADDON_CREDITS = 'addons_ai_credits500k';
export const ADDON_STORAGE = 'addons_storage_10gb';
export const ADDON_LEARNERS = 'addons_learner_or_instructor';
export const ADDON_AUTHORS = 'addons_course_author';

export const marketplaceItems = (tier: number) => [
  {
    image: aiMarketImg,
    text: getLocalizationBasedOnLang(
      'Reload AI credits to power your tapybl experience with cutting-edge AI',
      "Ail-lwythwch gredydau AI i bweru'ch profiad tapybl gyda deallusrwydd artiffisial arloesol",
    ),
    addonId: ADDON_CREDITS,
    buttonText: getLocalizationBasedOnLang('Reload now', 'Ail-lwythwch nawr'),
  },
  {
    image: storageMarketImg,
    text: getLocalizationBasedOnLang(
      'Increase storage to keep up with your growing needs',
      "Cynyddwch storio i gadw i fyny â'ch anghenion sy'n tyfu",
    ),
    addonId: ADDON_STORAGE,
    buttonText: getLocalizationBasedOnLang(
      'Increase storage now',
      'Cynyddwch storio nawr',
    ),
  },
  // {
  //   image: learnersMarketImg,
  //   text: getLocalizationBasedOnLang(
  //     'Scale as you go-add learners and instructors as needed',
  //     'Ehangwch wrth fynd—ychwanegwch ddysgwyr a hyfforddwyr yn ôl yr angen',
  //   ),
  //   addonId:
  //     isBusinessSubscription(tier) || tier === SUBSCRIPTION_ENTERPRISE
  //       ? undefined
  //       : ADDON_LEARNERS,
  //   buttonText: getLocalizationBasedOnLang(
  //     'Add more users',
  //     'Ychwanegwch mwy o ddefnyddwyr',
  //   ),
  //   quoteLink:
  //     isBusinessSubscription(tier) || tier === SUBSCRIPTION_ENTERPRISE
  //       ? 'https://help.tapybl.com/support/tickets/new?ticket_form=upgrade_plan'
  //       : undefined,
  // },
  {
    image: scormMarketImg,
    text: getLocalizationBasedOnLang(
      'Integrate SCORM for seamless learning management',
      'Integreiddiwch SCORM ar gyfer rheoli dysgu di-dor',
    ),
    quoteLink:
      'https://help.tapybl.com/support/tickets/new?ticket_form=upgrade_plan',
    buttonText: getLocalizationBasedOnLang(
      'Request a quote',
      'Gofynnwch am dyfynbris',
    ),
  },
  {
    image: instructorsMarkeImg,
    text: getLocalizationBasedOnLang(
      'Bring in more course creators to your workspace',
      "Dewch â Mwy o greawdwyr cyrsiau i'ch gweithle",
    ),
    addonId: isBusinessSubscription(tier) ? ADDON_AUTHORS : undefined,
    buttonText:
      isCreatorSubscription(tier) || tier === SUBSCRIPTION_ENTERPRISE
        ? getLocalizationBasedOnLang(
            'Request a quote',
            'Gofynnwch am dyfynbris',
          )
        : getLocalizationBasedOnLang(
            'Buy additional licenses',
            'Prynwch drwyddedau ychwanego',
          ),
    quoteLink:
      isCreatorSubscription(tier) || tier === SUBSCRIPTION_ENTERPRISE
        ? 'https://help.tapybl.com/support/tickets/new?ticket_form=upgrade_plan'
        : undefined,
  },
];

export const marketplaceCheckOutItems = [
  {
    image: aiMarketImg,
    title: getLocalizationBasedOnLang(
      'AI credit top-up',
      'Ail-lwytho credydau AI',
    ),
    description: getLocalizationBasedOnLang(
      'Get 500,000 AI credits instantly added to your account, ready to power all AI-driven features and services.',
      "Cafwch 500,000 credyd AI yn cael eu hychwanegu'n syth i'ch cyfrif, yn barod i bweru pob nodwedd a gwasanaeth sy'n cael ei driven gan AI",
    ),
    addonId: 'addons_ai_credits500k',
  },
  {
    image: storageMarketImg,
    title: getLocalizationBasedOnLang('Storage space', 'Mynediad storio'),
    description: getLocalizationBasedOnLang(
      'Increase your storage by 10 GB to support the creation and management of more engaging, interactive video experiences.',
      'Cynyddwch eich storio o 10 GB i gefnogi creu a rheoli profiadau fideo mwy deniadol ac rhyngweithiol',
    ),
    addonId: 'addons_storage_10gb',
  },
  {
    image: learnersMarketImg,
    title: getLocalizationBasedOnLang(
      'Add learners/instructors',
      'Ychwanegwch ddysgwyr/hyfforddwyr',
    ),
    description: getLocalizationBasedOnLang(
      "Scale as you go-add learners and instructors to expand your team or community. Whether you're growing your learner base or bringing in new instructors, seamlessly scale your educational environment. ",
      "Ehangwch wrth fynd—ychwanegwch Ddysgwyr a hyfforddwyr i ehangu eich tîm neu gymuned. P'un a ydych chi'n tyfu eich sylfaen dysgwyr neu'n dod â hyfforddwyr newydd, ehangwch eich amgylchedd addysgol yn ddi-dor",
    ),
    addonId: 'addons_learner_or_instructor',
  },
  {
    image: instructorsMarkeImg,
    title: getLocalizationBasedOnLang(
      'Additional licenses',
      'Trwyddedau ychwanego',
    ),
    description: getLocalizationBasedOnLang(
      'Add more course creators to your workspace by purchasing additional licenses. Collaborate with more content creators to build a rich, diverse interactive course catalog.',
      "Ychwanegwch fwy o greawdwyr cyrsiau i'ch gweithle trwy brynu trwyddedau ychwanegol. Cydweithredwch â mwy o greuwyr cynnwys i adeiladu catalog cyrsiau rhyngweithiol cyfoethog a divers.",
    ),
    addonId: 'addons_course_author',
  },
];

export const getPriceByTierAndAddon = (tier: number, addon: string) => {
  if (isCreatorSubscription(tier) || tier === SUBSCRIPTION_TRIAL) {
    switch (addon) {
      case 'addons_ai_credits500k':
        return 5;
      case 'addons_storage_10gb':
        return 9.25;
      case 'addons_learner_or_instructor':
        return 107.88;
      case 'addons_course_author':
        return -1;
    }
  }
  if (isBusinessSubscription(tier)) {
    switch (addon) {
      case 'addons_ai_credits500k':
        return 5;
      case 'addons_storage_10gb':
        return 9.25;
      case 'addons_learner_or_instructor':
        return 95.88;
      case 'addons_course_author':
        return isAnnualSubscription(tier) ? 100 : 9;
    }
  }
  if (tier === SUBSCRIPTION_ENTERPRISE) {
    switch (addon) {
      case 'addons_ai_credits500k':
        return 5;
      case 'addons_storage_10gb':
        return 9.25;
    }
  }
};
